// extracted by mini-css-extract-plugin
export var details = "_ge-0";
export var inspectorPopover = "_ge-1";